import { useTenantContext } from "@/lib/tenant-context";

/** Tenant activo en /app (respeta impersonación super_admin). */
export function useWorkspaceTenantId(): string {
  return useTenantContext().tenantId;
}
